import { FsRankemPartialPoints } from "db/model/pickemDetails/Rankem/FsRankemPartialPoints";
import { RankemPartialPoints } from "model/PickemDetails/Rankem/PartialPoints";
import { nonUndefined } from "Utility";

export const mapRankemPartialPoints = (fsModels: FsRankemPartialPoints[]) => {
  return nonUndefined(fsModels.map(mapRankemPartialPoint));
};

export const mapRankemPartialPoint = (
  fsModel: FsRankemPartialPoints
): RankemPartialPoints | undefined => {
  if (!fsModel.partialPercent || !fsModel.withinColumns) {
    return undefined;
  }

  return {
    partialPercent: fsModel.partialPercent,
    withinColumns: fsModel.withinColumns,
  };
};
